export class WhatsAppOfficialDashboardFiltro {
  public data_inicio: string;
  public data_fim: string;
  public seller_id: number;
  public etapa_id: number;
  public cliente: string;
}

export class WhatsAppOfficialDashboardFiltroOpcao {
  public id: number;
  public nome: string;
}

export class WhatsAppOfficialDashboardFunil {
  public etapa: string;
  public etapa_tipo: string;
  public quantidade: number;
}

export class WhatsAppOfficialDashboardVendedor {
  public seller_id: number;
  public vendedor: string;
  public atendimentos: number;
  public aberto: number;
  public atendimento: number;
  public ganho: number;
  public perda: number;
  public tempo_captura_medio_minutos: number;
}

export class WhatsAppOfficialDashboardDirecao {
  public primeira_mensagem_direcao: string;
  public aberto: number;
  public atendimento: number;
  public ganho: number;
  public perda: number;
}

export class WhatsAppOfficialDashboardMapaHora {
  public data_atendimento: string;
  public data_atendimento_label: string;
  public dia_semana: number;
  public dia_semana_nome: string;
  public hora: number;
  public quantidade: number;
}

export class WhatsAppOfficialDashboardInstancia {
  public seller_id: number;
  public vendedor: string;
  public status: string;
  public conectada: boolean;
}

export class WhatsAppOfficialDashboardSaudeInstancias {
  public conectadas: number = 0;
  public desconectadas: number = 0;
  public instancias: WhatsAppOfficialDashboardInstancia[] = [];
}

export class WhatsAppOfficialDashboardAtendimento {
  public id: number;
  public cliente: string;
  public telefone: string;
  public primeira_mensagem_direcao: string;
  public hr_abertura: string;
  public hr_captura: string;
  public hr_finalizacao: string;
  public tempo_captura_minutos: number;
  public seller_id: number;
  public vendedor_interno: string;
  public etapa: string;
  public etapa_tipo: string;
  public tempo_atendimento_minutos: number;
  public numero_mensagens: number;
}

export class WhatsAppOfficialDashboard {
  public atendimentos_abertos: number = 0;
  public em_atendimento: number = 0;
  public ganho: number = 0;
  public perda: number = 0;
  public tempo_medio_primeira_resposta_minutos: number = 0;
  public vendedoras: WhatsAppOfficialDashboardFiltroOpcao[] = [];
  public etapas: WhatsAppOfficialDashboardFiltroOpcao[] = [];
  public funil: WhatsAppOfficialDashboardFunil[] = [];
  public vendedores: WhatsAppOfficialDashboardVendedor[] = [];
  public direcoes: WhatsAppOfficialDashboardDirecao[] = [];
  public mapa_horas: WhatsAppOfficialDashboardMapaHora[] = [];
  public saude_instancias: WhatsAppOfficialDashboardSaudeInstancias = new WhatsAppOfficialDashboardSaudeInstancias();
  public atendimentos: WhatsAppOfficialDashboardAtendimento[] = [];
}
